export const commonColor = {
  WARN: '#FF9900',
  FAIL: '#E02020',
  WHITE: '#FFFFFF',
  NORMAL: '#19BE6B',
  BLUE: '#2B85E4',
  PINK: '#F7C0BA',
}
